import Icon from '~/components/icon';

export const WrappedIcon = ({
	className = '',
	dimensionString,
	iconString,
}: {
	className?: string;
	dimensionString: string;
	iconString: string;
}) => {
	if (!iconString) return null;

	const [icon, dimension = dimensionString] = iconString.split(',');

	return (
		<div className={className}>
			<Icon
				height={parseInt(dimension, 10)}
				icon={icon}
				width={parseInt(dimension, 10)}
			/>
		</div>
	);
};
